import { useMemo } from "react";
import { Table, TableBody } from "@mui/material";

import { useTenantTranslation } from "hooks/formatters";

import { useCraneDriver } from "../CraneDriverProvider";
import { getBasketLayerStack } from "../utils";
import { CraneTableHeader } from "./CraneTableHeader";
import { CraneTableRow } from "./CraneTableRow";
import { CraneTableTotalRow } from "./CraneTableTotalRow";
import { CraneTableActionRow } from "./CraneTableActionRow";
import { CraneRatioMaterialsRow } from "./CraneRatioMaterialsRow";
import { CraneTableSequenceLabelRow } from "./CraneTableSequenceLabelRow";

export const CraneTable = () => {
  const { assignedLoads, groupedMaterials } = useCraneDriver();
  const { t } = useTenantTranslation();

  const ratioMaterials = groupedMaterials.filter(
    (material) => Object.values(material.layerInfo)[0]?.unit === "ratio"
  );

  const stacks = useMemo(
    () =>
      assignedLoads.map((basket) => ({
        basket,
        layers: getBasketLayerStack(basket),
      })),
    [assignedLoads]
  );
  const maxStackHeight = Math.max(
    0,
    ...stacks.map((stack) => stack.layers.length)
  );

  return (
    <Table stickyHeader size="medium">
      <CraneTableHeader />
      <TableBody>
        <CraneRatioMaterialsRow ratioMaterials={ratioMaterials} />
        {maxStackHeight > 0 && (
          <CraneTableSequenceLabelRow label={t("bottomFirst")} />
        )}
        {Array.from({ length: maxStackHeight }, (_, position) => (
          <CraneTableRow key={position} position={position} stacks={stacks} />
        ))}
        {maxStackHeight > 0 && (
          <CraneTableSequenceLabelRow label={t("topLast")} />
        )}
        <CraneTableTotalRow />
        <CraneTableActionRow />
      </TableBody>
    </Table>
  );
};
